import {WEBSITE_ROOT_URL} from '@fo/shared-types/constants';

const getCanonicalUrl = (route: string): string => `${WEBSITE_ROOT_URL}${route}`;

export default getCanonicalUrl;
